import React from 'react'
import { List } from 'immutable'
import { Grid } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import { ILocalizedLanguage } from 'store/locale/types'
import { IImage } from 'hooks/useImages'
import { Image } from 'components/ui/DataDisplay/Image'
import { Link } from 'components/ui/Behaviors/Link'
import { Clickable } from 'components/ui/Behaviors/Clickable'
import { LanguageSelector } from 'components/ui/DataFilter/LanguageSelector'
import { useStyles } from './SmallScreenNavigationBar.styles'
import { ReactComponent as Burger } from './assets/burger.svg'

interface ISmallScreenNavigationBarProps {
  logo: IImage
  selectedLanguage: string
  languages: List<ILocalizedLanguage>
  onSelectLanguage: (language: string) => void
  onBurgerClick: () => void
  closedOrOpenedBurger: boolean
}

export const SmallScreenNavigationBar = ({
  logo,
  onSelectLanguage,
  selectedLanguage,
  languages,
  onBurgerClick,
  closedOrOpenedBurger
}: ISmallScreenNavigationBarProps) => {
  const classes = useStyles()

  return (
    <Grid container className={classes.root}>
      <Grid item xs={3}>
        <Clickable onClick={onBurgerClick} className={classes.contentBurger}>
          {!closedOrOpenedBurger ? <Burger /> : <Close className={classes.svgClosed} />}
        </Clickable>
      </Grid>
      <Grid item container xs={6} alignItems="center" justifyContent="center" className={classes.logoLinkWrapper}>
        <Link route={logo.link}>
          <Image height={'2rem'} ratio={2.42} backgroundUrl={logo.url} highlightable={false} />
        </Link>
      </Grid>
      <Grid item xs={3}>
        <LanguageSelector active={selectedLanguage} languages={languages} onSelect={onSelectLanguage} />
      </Grid>
    </Grid>
  )
}
